import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class SendMessageActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.type) {
            throw new ValidationError('The message content type is required', '');
        }
        if (!model.content) {
            throw new ValidationError('The message content is required');
        }
    }
}
